export default "__VITE_ASSET__q4dWx56v__"